export default __webpack_public_path__ + "static/media/insights_view_icon.19d3cfba.svg";